import React from 'react';

interface SearchToggleProps {
  checked: boolean;
  id?: string;
  label: string;
  onChange: (checked: boolean) => void;
}

/** Small brand-colored switch used by the flights searcher (prototipo v18). */
export const SearchToggle: React.FC<SearchToggleProps> = ({ checked, id, label, onChange }) => (
  <span className='searcher-form__inline-toggle'>
    <label className='searcher-form__switch'>
      <input
        aria-label={label}
        checked={checked}
        id={id}
        onChange={(event) => onChange(event.target.checked)}
        type='checkbox'
      />
      <i aria-hidden='true' />
    </label>
    <span className='searcher-form__inline-toggle-text'>{label}</span>
  </span>
);

interface CurrencyToggleProps {
  currency: string;
  onChange: (currency: string) => void;
}

/** USD ↔ ARS switch shown above Buscar for Argentina agencies (prototipo v18). */
export const CurrencyToggle: React.FC<CurrencyToggleProps> = ({ currency, onChange }) => (
  <div className='searcher-form__currency-toggle'>
    <span>USD</span>
    <label className='searcher-form__switch'>
      <input
        aria-label='Moneda'
        checked={currency === 'ARS'}
        onChange={(event) => onChange(event.target.checked ? 'ARS' : 'USD')}
        type='checkbox'
      />
      <i aria-hidden='true' />
    </label>
    <span>ARS</span>
  </div>
);

export const PAIS_ID_ARGENTINA = 1;

export function showsFlightCurrencyToggle(paisId?: number | null): boolean {
  return Number(paisId) === PAIS_ID_ARGENTINA;
}
